<template>
  <div class="scroll-hidden monitoring-table-wrapper shadow-monitoring">
    <global-loading v-if="$store.state.monitoringStore.sio_expire_soon_loading" />
    <div class="pointer" style="position:absolute;right:2%;top:2%;font-size:20px">
      <i class="fa-solid fa-file-arrow-down" style="color:red" @click="downloadReport()"></i>
    </div>
    <div class="text-sm text-bold">
      Detail SIO Expired Soon by Activity
    </div>
    <div class="mt10">
      <div class="brl-top-table-header border-bottom">
        <div class="brl-top-table-material">
          Nomor SIO
          <span class="pointer" @click="noSioSortFunction()">
            <i class="fas fa-arrow-down" v-show="noSioSort"></i><i class="fas fa-arrow-up" v-show="!noSioSort"></i>
          </span>
        </div>
        <div class="brl-top-table-vendor">
          Vendor Name
          <span class="pointer" @click="vendorSortFunction()">
            <i class="fas fa-arrow-down" v-show="vendorSort"></i><i class="fas fa-arrow-up" v-show="!vendorSort"></i>
          </span>
        </div>
        <div class="brl-top-table-vendor">
          Expired Date
          <span class="pointer" @click="expiredSortFunction()">
            <i class="fas fa-arrow-down" v-show="expiredSort"></i><i class="fas fa-arrow-up" v-show="!expiredSort"></i>
          </span>
        </div>
      </div>
      <div>
        <div class="brl-top-table-header" v-for="(item, index) in detailSioExpireSoon" :key="index">
          <div class="brl-top-table-material col-elipsis">
            {{ item.nomor }}
          </div>
          <div class="brl-top-table-vendor col-elipsis">
            {{ item.nama_vendor }}
          </div>
          <div class="brl-top-table-vendor text-orange-bold">
            +{{ item.selisih_hari }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
import moment from 'moment'
export default {
  components: {
    barChart: () => import('@/components/chart/dashboard/bar-chart.vue'),
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      listVendor: [
        {
          noSio: '048/BC/KTT-FIY/I/2023',
          vendor: 'Az-Zahra',
          expiredDate: 10,
        },
        {
          noSio: '047/BC/KTT-FIY/I/2023',
          vendor: 'Az-Zahra',
          expiredDate: 9,
        },
        {
          noSio: '046/BC/KTT-FIY/I/2023',
          vendor: 'Az-Zahra',
          expiredDate: 60,
        },
        {
          noSio: '045/BC/KTT-FIY/I/2023',
          vendor: 'Az-Zahra',
          expiredDate: 60,
        },
        {
          noSio: '044/BC/KTT-FIY/I/2023',
          vendor: 'Az-Zahra',
          expiredDate: 50,
        },
        {
          noSio: '043/BC/KTT-FIY/I/2023',
          vendor: 'Az-Zahra',
          expiredDate: 50,
        },
        {
          noSio: '042/BC/KTT-FIY/I/2023',
          vendor: 'Az-Zahra',
          expiredDate: 40,
        },
        {
          noSio: '041/BC/KTT-FIY/I/2023',
          vendor: 'Az-Zahra',
          expiredDate: 30,
        },
      ],
      noSioSort: false,
      vendorSort: false,
      expiredSort: false,
    }
  },

  computed: {
    detailSioExpireSoon() {
      const data = this.$store.state.monitoringStore.sio_expire_soon

      return data
    },
  },

  methods: {
    noSioSortFunction() {
      this.noSioSort = !this.noSioSort

      this.detailSioExpireSoon.sort((a, b) => {
        if (this.noSioSort) {
          return a.nomor.localeCompare(b.nomor)
        } else {
          return b.nomor.localeCompare(a.nomor)
        }
      })
    },
    vendorSortFunction() {
      this.vendorSort = !this.vendorSort
      if (this.vendorSort) {
        this.detailSioExpireSoon.sort((a, b) =>
          a.nama_vendor.localeCompare(b.nama_vendor)
        )
      } else {
        this.detailSioExpireSoon.sort((a, b) =>
          b.nama_vendor.localeCompare(a.nama_vendor)
        )
      }
    },
    expiredSortFunction() {
      this.expiredSort = !this.expiredSort

      this.detailSioExpireSoon.sort((a, b) => {
        if (this.expiredSort) {
          return a.selisih_hari - b.selisih_hari
        } else {
          return b.selisih_hari - a.selisih_hari
        }
      })
    },
    downloadReport() {
      const exportTitle = 'SIO Expired Soon by Activity'
      let newData = this.detailSioExpireSoon.map((item, index) => {
        let newDataItem = {
          no: index + 1,
          nomor: item.nomor,
          nama_vendor: item.nama_vendor,
          selisih_hari: item.selisih_hari,
        }

        return newDataItem
      })

      newData.unshift({})

      let wb = XLSX.utils.book_new()
      let sheet = [exportTitle]
      sheet.forEach(list => {
        let dataToExport = XLSX.utils.json_to_sheet(newData)
        const title = [
          ['', '', ''],
          ['No', 'Nomor SIO', 'Nama Vendor', 'Expired Date'],
        ]
        XLSX.utils.book_append_sheet(wb, dataToExport, list)
        XLSX.utils.sheet_add_aoa(dataToExport, title, {
          origin: 'A1',
        })
      })
      XLSX.writeFile(wb, `${exportTitle}.xlsx`)
    },
  },
}
</script>
<style scoped>
.region-container {
  width: 30%;
  font-size: 14px;
  font-weight: bold;
  border-top: 0.5px solid rgba(128, 128, 128, 0.3);
  border-right: 0.5px solid rgba(128, 128, 128, 0.3);
  text-align: right;
  padding-right: 5px;
}

.custom-bar-container {
  width: 70%;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.custom-bar-box {
  display: flex;
  height: 15px;
}

.custom-bar-color {
  border: 0.3px solid rgba(255, 192, 203);
  background: rgb(204, 0, 0);
  background: linear-gradient(90deg,
      rgba(204, 0, 0, 0.5) 0%,
      rgba(204, 0, 0, 0.3) 50%,
      rgba(255, 255, 255, 0.5) 100%);
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

.region-value {
  font-size: 12px;
}

.text-orange-bold {
  color: #ff914c;
  font-weight: 700;
}
</style>
